var module = angular.module('octopusApp.shared');

module.controller('ExportEntityDialogController', function($scope, $uibModalInstance, entity, entityType, $rootScope){

  // _Shallow_ clone.
  var cloned = _.clone(entity);

  cloned = _.omit(cloned, 'Links');

  cloned.$Meta = { ExportedAt: new Date(), OctopusVersion: $rootScope.octopusVersion, Type: entityType };

  $scope.entityJson = JSON.stringify(cloned, null, 2);

  $scope.close = function() {
    $uibModalInstance.close();
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/controllers/export_entity_dialog_controller.js
// module id = 580
// module chunks = 1